module.exports = __webpack_public_path__ + "build/img/4.bd449a03.png";